export const options = {
    autoConfig: true,
    debug: false,
};

export const pixelID = '3784481815098038';